import ContentAudio from "@/react/story/components/viewers/contents/ContentAudio";
import ContentImage from "@/react/story/components/viewers/contents/ContentImage";
import ContentLocalePicker from "@/react/story/components/viewers/contents/ContentLocalePicker";
import ContentOrigin from "@/react/story/components/viewers/contents/ContentOrigin";
import ContentText from "@/react/story/components/viewers/contents/ContentText";
import ContentVideo from "@/react/story/components/viewers/contents/ContentVideo";
import { type Content, ContentTypeEnum } from "@/react/story/types";

type Props = {
    content: Content;
}

export default function ViewerContent(props: Props) {
    return {
        [ContentTypeEnum.TITLE]: <ContentText content={props.content} tag="h1" />,
        [ContentTypeEnum.SUBTITLE]: <ContentText content={props.content} tag="h2" />,
        [ContentTypeEnum.PARAGRAPH]: <ContentText content={props.content} tag="p" />,
        [ContentTypeEnum.IMAGE]: <ContentImage content={props.content} />,
        [ContentTypeEnum.ORIGIN]: <ContentOrigin content={props.content} />,
        [ContentTypeEnum.VIDEO]: <ContentVideo content={props.content} />,
        [ContentTypeEnum.AUDIO]: <ContentAudio content={props.content} />,
        [ContentTypeEnum.LOCALE_PICKER]: <ContentLocalePicker content={props.content} />,
    }[props.content.type] ?? null;
}
